import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import "./InfoPages.css";

export default function InfoLayout({ label, title, subtitle, children }) {
  return (
    <div className="fi-page">
      <section className="fi-hero">
        <div className="fi-container">
          <nav aria-label="Breadcrumb" className="fi-breadcrumb">
            <Link to="/">Home</Link><ChevronRight size={13}/><span>{label}</span>
          </nav>
          <span className="fi-kicker">FindAutoParts <span aria-hidden="true">/</span> {label}</span>
          <h1>{title}</h1>
          <p>{subtitle}</p>
        </div>
      </section>
      <main className="fi-content"><div className="fi-container">{children}</div></main>
      <footer className="fi-footer">
        <div className="fi-container fi-footer-grid">
          <div><strong>FindAutoParts</strong><small>Connecting vehicle owners and workshops with replacement parts.</small></div>
          <nav aria-label="Information pages">
            <Link to="/about">About Us</Link>
            <Link to="/support">Support</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/search">Find Parts</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}
